import { render, staticRenderFns } from "./MakerNew.vue?vue&type=template&id=507b6833&scoped=true"
import script from "./MakerNew.vue?vue&type=script&lang=js"
export * from "./MakerNew.vue?vue&type=script&lang=js"
import style0 from "./MakerNew.vue?vue&type=style&index=0&id=507b6833&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507b6833",
  null
  
)

export default component.exports